import { useContext } from "react";

import { useGetZonesGeographiesZonesGet } from "@/services/2/react-query/hooks";

import { LegalEntityContext } from "../legal-entity-context";
import { MultiSelectDropdown } from "../multiselect-dropdown";

type MultiZoneSelectorProps = {
  selectedZones: string[];
  onChange: (newValues: string[]) => void;
};

export const MultiZoneSelector = ({ selectedZones, onChange }: MultiZoneSelectorProps) => {
  const legalEntityContext = useContext(LegalEntityContext);

  const { data: zones } = useGetZonesGeographiesZonesGet(
    {
      query: { legal_entity_uuids: legalEntityContext ? [legalEntityContext] : [] },
    },
    [legalEntityContext || "all"],
    {
      staleTime: 60 * 60 * 1000, // 1 hour
    }
  );
  const sortedZones = !zones ? [] : zones.sort((a, b) => a.name.localeCompare(b.name));

  return (
    <MultiSelectDropdown
      name="zones"
      label="Zone"
      pluralLabel="Zones"
      options={sortedZones.map(zone => ({
        value: zone.uuid,
        label: zone.name,
      }))}
      values={selectedZones}
      onChangeValues={onChange}
    />
  );
};
